/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "#/lib/social-signal-api-client.ts"
import type {
  RequestConfig,
  ResponseErrorConfig,
} from "#/lib/social-signal-api-client.ts"
import type {
  SendFollowRequestMutationRequest,
  SendFollowRequestMutationResponse,
  SendFollowRequest400,
  SendFollowRequest401,
  SendFollowRequest409,
} from "../types/SendFollowRequest.ts"
import {
  sendFollowRequestMutationResponseSchema,
  sendFollowRequestMutationRequestSchema,
} from "../zod/sendFollowRequestSchema.ts"

function getSendFollowRequestUrl() {
  const res = { method: "POST", url: `/follow-requests` as const }
  return res
}

/**
 * @summary Send a follow request to another user
 * {@link /follow-requests}
 */
export async function sendFollowRequest(
  data: SendFollowRequestMutationRequest,
  config: Partial<RequestConfig<SendFollowRequestMutationRequest>> & {
    client?: typeof fetch
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = sendFollowRequestMutationRequestSchema.parse(data)

  const res = await request<
    SendFollowRequestMutationResponse,
    ResponseErrorConfig<
      SendFollowRequest400 | SendFollowRequest401 | SendFollowRequest409
    >,
    SendFollowRequestMutationRequest
  >({
    method: "POST",
    url: getSendFollowRequestUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return sendFollowRequestMutationResponseSchema.parse(res.data)
}
